import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import './i18n';
import App from './App';
import { DataProvider } from './DataContext'
import reportWebVitals from './reportWebVitals';

function do_check()
{
    var return_value=prompt("Password:");
    if(return_value==="Epas@2021")
      ReactDOM.render(
        <DataProvider>
          <App />
        </DataProvider>,
        document.getElementById('root')
      );
    else
      do_check();
}

// do_check();

ReactDOM.render(
        <DataProvider>
          <App />
        </DataProvider>,
        document.getElementById('root')
      );

reportWebVitals();
